import { IIconBase } from '..'

const detailYellowIcon = ({
  color = '#664D03',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.33337 1.33545H6.00004C2.66671 1.33545 1.33337 2.66878 1.33337 6.00212V10.0021C1.33337 13.3354 2.66671 14.6688 6.00004 14.6688'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6667 6.66895V8.66895'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6667 6.66878H12C10 6.66878 9.33337 6.00212 9.33337 4.00212V1.33545L14.6667 6.66878Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.0689 12.5298L12.9476 14.4084'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.7506 12.0016C11.4714 11.2343 11.4337 10.0279 10.6663 9.3071C9.89896 8.58629 8.69258 8.62402 7.97177 9.39136C7.25096 10.1587 7.28868 11.3651 8.05603 12.0859C8.82337 12.8067 10.0298 12.769 10.7506 12.0016Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default detailYellowIcon
